import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./App.scss";
import store, { persistedStore } from "./redux";
import MainContainer from "./router";
import { PersistGate } from "redux-persist/integration/react";
import { SentryErrorBoundary } from "./sentry";
import {
  restoreConnectDeviceIfNeeded,
  saveConnectDeviceRestoreUrl,
} from "./utils/connectDeviceRestore";
import { installAndroidKeyboardHeightBridge } from "./utils/androidKeyboardHeightBridge";
import "./i18n";

installAndroidKeyboardHeightBridge();

// Restore a saved connect-device hash if needed (sets hash before React mounts).
// Always render the app afterwards — hash-only changes don't trigger page reloads,
// so skipping the render would leave a permanent white screen.
restoreConnectDeviceIfNeeded();
saveConnectDeviceRestoreUrl();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <SentryErrorBoundary
    fallback={({ error }) => <div>An error has occurred</div>}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <MainContainer />
      </PersistGate>
    </Provider>
  </SentryErrorBoundary>
);
